class Resource {

	static fromArray(data, list){
		let inst = new Resource(list);

		inst._id = data.shift();
		inst._name = data.shift();
		inst._desc = data.shift();
		inst._type = data.shift();
		inst._graphic = data.shift();
		inst._ownerId = data.shift();
		inst._ownerName = data.shift();
		inst._createdOn = data.shift();
		inst._accessMode = data.shift();
		inst._mobileSync = data.shift();

		inst.buildElem();
		return inst;
	}

	constructor(list) {
		this._list = list;

		this._id = 0;
		this._name;
		this._desc;
		this._type;
		this._graphic;
		this._ownerId;
		this._ownerName;
		this._createdOn;

		this._accessMode;
		this._mobileSync;
	}

	buildElem() {
		switch (this._type) {
			case 1: this._typeName = 'guide'; break;
			case 2: this._typeName = 'checklist'; break;
		}

		if (isCommunity) {
			this._shareBtn = btn('btn i-rg i-availability tooltip', null, null, {
				'data-tip': _("Availability to community members")
			});
		}
		else {
			this._shareBtn = btn('btn i-rg i-share tooltip', null, null, {
				'data-tip':_("Resource sharing")
			});
		}

		this._elem = div(null, [
			this._chkBox = chk('alt-chk'),
			div('list-row mx-4 align-items-center hilight', [
				div('col-auto i-rg chk-box', null, {'click': this.select.bind(this)}),
				img('list-row-graphic', graphicSrc(this._graphic, AC.GRAPHIC_MED)),
				div('col-4', [
					icon(this._typeName),
					this._name
				]),
				div('col-2', [
					timeAgo(this._createdOn),
				]),
				div('col-2', this._ownerName),
				div('col-auto ms-auto', [
					label(null, [
						this._syncCheck = chk('masked'),
						icon('phone-sync', 'lg', 'mask')
					], {
						'click': ev => stopEv(ev)
					}),
					this._tagBtn = btn('btn i-rg i-tags tooltip', null, null, {
						'data-tip':_("Select resource tags"),
						'data-pos': 'above-left'
					}),
					this._shareBtn
				])
			])
		]);

		this._syncCheck.checked = this._mobileSync !== 0;
		this._shareBtn.disabled = this._accessMode < AC.ACCESS_FULL;

		onEv(this._syncCheck, 'change', this.setMobile.bind(this));
		onEv(this._tagBtn, 'click', this.showTags.bind(this));
		onEv(this._shareBtn, 'click', this.showSharing.bind(this));
		onEv(this._elem, 'click', this.open.bind(this));
	}

	get id() {return this._id;}

	get elem() {return this._elem;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = v;}

	open(ev) {
		if (selection.empty) {
			window.location.assign(this._typeName + '/' + this._id);
		} 
		else {
			this.select(ev);
		}
	}

	select(ev) {
		stopEv(ev);
		selection.toggle(this);
	}

	setMobile() {
		ajg('resources/set-mobile', [
			'id=' + this._id,
			'value=' + (this._syncCheck.checked ? 1 : 0)
		], null, (reply) => {
			showError(reply);
		});
	}

	showTags(event) {
		stopEv(event);
		if (typeof tags === 'undefined' || !tags instanceof TagList) return;
		tags.mapOne(this.id, this._tagBtn, event);
	}

	showSharing(ev) {
		stopEv(ev);
		if (typeof sharing === 'undefined' || !sharing instanceof Sharing) return;
		if (isCommunity) {
			sharing.mapOne(this.id, this._shareBtn);
		}
		else {
			sharing.mapOne(this.id);
		}
	}

	delete() {
		//TODO - delete resource function
	}
}